import { coreApi } from 'src/api/config';
import { convertCoreDocuments } from 'src/api/utils/fileUploadUtils';
import convertCorePaging from 'src/api/utils/convertCorePaging';
import { isHttpSuccess } from 'src/api/utils/httpStatus';
import { FETCH_CONTACT_DOCUMENTS } from 'actions';
import Notifier from 'common/helpers/Notifier';

const fetchContactDocuments = ({
  contactId,
  notifyError = false,
  page = 1,
  perPage = 30,
}) => (
  async (dispatch) => {
    const response = await coreApi.query(
      'file_uploads',
      {
        record: contactId,
        'record.type': 'person',
      },
      {
        page: {
          number: page,
          size: perPage,
        },
      },
    );

    let documents = response.data.data;
    documents = convertCoreDocuments(documents);

    const paging = response.data.meta?.page ?
      convertCorePaging(response.data.meta.page) :
      {};

    const payload = { data: { data: documents, paging } };

    if (!isHttpSuccess(response.status)) {
      if (notifyError) {
        Notifier.handleErrors(response);
      }
      return response;
    }

    dispatch({
      type: FETCH_CONTACT_DOCUMENTS,
      payload,
      contactId,
    });

    return payload;
  }
);

export default fetchContactDocuments;
